import React from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

/**
 * Tabs that are routes: each tab links to its path, so a deep link or reload
 * lands on the right tab and the active one carries aria-current="page". A row
 * wider than the screen scrolls on its own, never the page.
 */
const Tabs: React.FunctionComponent<{
  /** Names the tab row's nav landmark. */
  label: string;
  tabs: { label: React.ReactNode; to: string }[];
  className?: string;
}> = ({ label, tabs, className }) => (
  <div className={twMerge("overflow-x-auto", className)}>
    <nav aria-label={label} className="flex border-b border-gray-200">
      {tabs.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            classNames(
              "-mb-px whitespace-nowrap border-b-2 px-5 py-3 text-sm font-semibold",
              isActive
                ? "border-primary-1 text-primary-1"
                : "border-transparent text-gray-600 hover:text-primary-3",
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  </div>
);

export default Tabs;
